import { Link } from "react-router-dom";

const CreativeAgencyTwoInfocardLarge = () => {
  return (
    <>
      <div className="ca-two-info-card-lg-area pb-60">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <h2 className="ca-two-title ca-two-body-clr-two fs-36 fw-500 flh-48 pr-20 mt-20">
                Features offer valuable assistance in crafting imaginative forms
                as well
              </h2>
            </div>
            <div className="col-lg-6">
              <div className="ca-two-info-card ca-two-border ca-two-border-color rounded-16 padding-6 pt-40 ca-two-hover-bg ca-two-border-hover mt-20">
                <div className="d-flex align-items-center gap-8">
                  <img
                    src="assets/img/creative-agency-2/info_icon_4.svg"
                    alt=""
                    className="ca-two-info-icon"
                  />
                  <div className="ca-two-card-content">
                    <h5 className="ca-two-body-clr-two fs-20 mb-20">
                      Social Media Management
                    </h5>
                    <p className="ca-two-body-clr flh-24 fch-55 mb-0">
                      With our social media management, we amplify your online
                      voice, foster meaningful connections.
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <Link
                    href="assets/img/creative-agency-two"
                    className="ca-two-arrow-btn ca-two-bg d-inline-flex align-items-center justify-content-center"
                  >
                    <span className="clr-text fs-12">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="ca-two-info-card ca-two-border ca-two-border-color rounded-16 padding-6 pt-40 ca-two-hover-bg ca-two-border-hover mt-20">
                <div className="d-flex align-items-center gap-8">
                  <img
                    src="assets/img/creative-agency-2/info_icon_5.svg"
                    alt=""
                    className="ca-two-info-icon"
                  />
                  <div className="ca-two-card-content">
                    <h5 className="ca-two-body-clr-two fs-20 mb-20">
                      Branding Design
                    </h5>
                    <p className="ca-two-body-clr flh-24 fch-55 mb-0">
                      In the realm of creative design, we bring your visions to
                      life with a burst of imagination and a palette of
                      innovation.
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <Link
                    href="assets/img/creative-agency-two"
                    className="ca-two-arrow-btn ca-two-bg d-inline-flex align-items-center justify-content-center"
                  >
                    <span className="clr-text fs-12">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="ca-two-info-card ca-two-border ca-two-border-color rounded-16 padding-6 pt-40 ca-two-hover-bg ca-two-border-hover mt-20">
                <div className="d-flex align-items-center gap-8">
                  <img
                    src="assets/img/creative-agency-2/info_icon_6.svg"
                    alt=""
                    className="ca-two-info-icon"
                  />
                  <div className="ca-two-card-content">
                    <h5 className="ca-two-body-clr-two fs-20 mb-20">
                      Analytics and Reporting
                    </h5>
                    <p className="ca-two-body-clr flh-24 fch-55 mb-0">
                      Our analytics and reporting services provide you with
                      data-driven insights to steer your strategy.
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <Link
                    href="assets/img/creative-agency-two"
                    className="ca-two-arrow-btn ca-two-bg d-inline-flex align-items-center justify-content-center"
                  >
                    <span className="clr-text fs-12">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="ca-two-info-card ca-two-border ca-two-border-color rounded-16 padding-6 pt-40 ca-two-hover-bg ca-two-border-hover mt-20">
                <div className="d-flex align-items-center gap-8">
                  <img
                    src="assets/img/creative-agency-2/info_icon_7.svg"
                    alt=""
                    className="ca-two-info-icon"
                  />
                  <div className="ca-two-card-content">
                    <h5 className="ca-two-body-clr-two fs-20 mb-20">
                      Web Development
                    </h5>
                    <p className="ca-two-body-clr flh-24 fch-55 mb-0">
                      Our web development expertise goes beyond coding; it's
                      about building digital experiences that captivate
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <Link
                    href="assets/img/creative-agency-two"
                    className="ca-two-arrow-btn ca-two-bg d-inline-flex align-items-center justify-content-center"
                  >
                    <span className="clr-text fs-12">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="ca-two-info-card ca-two-border ca-two-border-color rounded-16 padding-6 pt-40 ca-two-hover-bg ca-two-border-hover mt-20">
                <div className="d-flex align-items-center gap-8">
                  <img
                    src="assets/img/creative-agency-2/info_icon_8.svg"
                    alt=""
                    className="ca-two-info-icon"
                  />
                  <div className="ca-two-card-content">
                    <h5 className="ca-two-body-clr-two fs-20 mb-20">
                      E-commerce Solutions
                    </h5>
                    <p className="ca-two-body-clr flh-24 fch-55 mb-0">
                      Our web development expertise goes beyond coding; it's
                      about building digital experiences that captivate
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <Link
                    href="assets/img/creative-agency-two"
                    className="ca-two-arrow-btn ca-two-bg d-inline-flex align-items-center justify-content-center"
                  >
                    <span className="clr-text fs-12">
                      <i className="fas fa-arrow-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyTwoInfocardLarge;
